import { useCallback, useState } from 'react';

/** Marks a request that failed, as distinct from one that returned no rows. */
export const LOAD_FAILED = Symbol('ri-load-failed');

/**
 * Resolve a request to its result, or to LOAD_FAILED when it rejects, so a
 * Promise.all batch keeps going and still knows which member failed.
 * @param {Promise<any>} promise
 * @returns {Promise<any>}
 */
export const orFailed = (promise) => promise.catch(() => LOAD_FAILED);

/**
 * @param {any} value a result from orFailed
 * @returns {boolean} true when the request behind it failed
 */
export const didFail = (value) => value === LOAD_FAILED;

/**
 * A reload counter for "Try again": add `reloadKey` to a load effect's deps and
 * call `retry` to re-run it.
 * @returns {[number, () => void]}
 */
export function useReload() {
  const [reloadKey, setReloadKey] = useState(0);
  const retry = useCallback(() => setReloadKey((k) => k + 1), []);
  return [reloadKey, retry];
}
